import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { isMobileDevice, setCurrencyFormat } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import {
    getTotalQuantity,
    flattenLotSerialArrayOfArrays,
    getTotalUsedQuantity,
    getTotalOtherQuantity,
} from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { getPriceInNumberDataType } from 'src/pages/reportUsage/utils/dataModificaionUtil';
import { StyledTotalPrice } from 'src/pages/reportUsage/record/components/priceOverride/index.styled.jsx';
import { useSelector } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
const useStyles = makeStyles(() => ({
    paper: {
        padding: '16px 0px 16px 16px',
        fontFamily: 'AvenirNextWorld Demi',
        fontSize: '14px',
        letterSpacing: '0px',
        color: '#3c3c3c',
        opacity: '1',
    },
    totalAmount: {
        fontFamily: 'AvenirNextWorld Demi',
        color: '#140F4B',
    },
    desktopStyle: {
        fontFamily: 'AvenirNextWorld Regular',
        fontSize: '14px',
        letterSpacing: '0.1px',
        color: '#393939',
        opacity: 1,
        lineHeight: '19px',
        display: 'flex',
    },
    divStyle: { marginRight: '5px' },
    mobileStyle: {
        fontFamily: 'AvenirNextWorld Regular',
        fontSize: '14px',
        letterSpacing: '0.1px',
        color: '#393939',
        opacity: 1,
        lineHeight: '19px',
        display: 'flex',
        flexDirection: 'column',
    },
    unmodifiedPrices: {
        fontFamily: 'AvenirNextWorld Regular',
        fontSize: '14px',
        letterSpacing: '0.1px',
        color: '#000000',
        opacity: '1',
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'column',
    },
    unmodifiedTotalPrice: {
        fontFamily: 'AvenirNextWorld Demi',
        fontSize: '14px',
        letterSpacing: '0.1px',
        color: '#140F4B',
        opacity: '1',
        textAlign: 'right',
        display: 'flex',
        flexDirection: 'column',
    },
    strikedPrices: {
        color: '#E5047E',
        textAlign: 'end',
        textDecoration: 'line-through',
    },
    inlineStyle: {
        display: 'flex',
        flexDirection: 'row',
    },
}));

const SummaryMobile = (props) => {
    const [tissueFlag, setTissueFlag] = useState(false);
    const [nonTissueFlag, setNonTissueFlag] = useState(false);
    const [accountOwnedFlag, setAccountOwnedFlag] = useState(false);
    const classes = useStyles();
    const [tProductQty, setTProductQty] = useState(0);
    const [nTproductQty, setNTProductQty] = useState(0);
    const [accProductQty, setAccProductQty] = useState(0);
    const [nTAmount, setNTAmount] = useState(0);
    const [tAmount, setTAmount] = useState(0);
    const [accAmount, setAccAmount] = useState(0);
    const [nTAdjAmount, setNTAdjAmount] = useState(0);
    const [tAdjAmount, setTAdjAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalAdjustedAmount, setTotalAdjustedAmount] = useState(0);
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    useEffectWithErrorLogging(() => {
        let nonTissueProdList;
        let tissueProdList;
        let accountOwnedList;

        if (props.itemTableData && props.itemTableData.length > 0) {
            //filter for accountOwned list
            accountOwnedList = props.itemTableData.filter(
                (item) => item.accountOwned === true
            );
            if (accountOwnedList && accountOwnedList.length > 0) {
                var accountOwnedTotal = accountOwnedList.reduce(
                    (total, accItem) => {
                        return (
                            total +
                            accItem.lotSerial.reduce((sum, curr) => {
                                if (curr.used || curr.other) {
                                    sum =
                                        sum +
                                        (curr.used === true
                                            ? 1
                                            : parseInt(
                                                  curr.used ? curr.used : 0
                                              )) +
                                        (curr.other === true
                                            ? 1
                                            : parseInt(
                                                  curr.other ? curr.other : 0
                                              ));
                                } else {
                                    sum = 1;
                                }
                                return sum;
                            }, 0)
                        );
                    },
                    0
                );
                setAccountOwnedFlag(true);
            } else {
                setAccountOwnedFlag(false);
            }
            setAccProductQty(parseInt(accountOwnedTotal));
            setAccAmount(0);
            //filter for tissue list
            tissueProdList = props.itemTableData.filter(
                (item) => item.salesOrg === 'S030' && !item.accountOwned
            );
            if (tissueProdList?.length > 0) {
                var tissueTotal = tissueProdList.reduce((total, tItem) => {
                    if (tItem && tItem.lotSerial) {
                        return (
                            total +
                            tItem.lotSerial.reduce((sum, curr) => {
                                if (curr.used || curr.other) {
                                    sum =
                                        sum +
                                        (curr.used ? 1 : 0) +
                                        (curr.other ? 1 : 0);
                                }
                                return sum;
                            }, 0)
                        );
                    } else {
                        return 0;
                    }
                }, 0);
                const tissueAmount = props.itemTableData
                    .filter(
                        (item) => item.salesOrg === 'S030' && !item.accountOwned
                    )
                    .reduce((prev, current) => {
                        const extPrice = getPriceInNumberDataType(
                            current.extPrice
                        );
                        return prev + extPrice;
                    }, 0);
                setTAmount(parseFloat(tissueAmount));
                const tissueAdjAmount = props.itemTableData
                    .filter(
                        (item) => item.salesOrg === 'S030' && !item.accountOwned
                    )
                    .reduce((prev, curr) => {
                        const tAdjExtPrice =
                            !curr.adjustedUsedQtyPrice &&
                            !curr.adjustedOtherQtyPrice
                                ? getPriceInNumberDataType(
                                      curr.extPrice && curr.extPrice !== ''
                                          ? curr.extPrice
                                          : curr.basePrice
                                          ? curr.basePrice
                                          : 0
                                  )
                                : getPriceInNumberDataType(
                                      curr.adjustedUsedQtyPrice
                                          ? curr.adjustedUsedQtyPrice
                                          : curr.basePrice
                                  ) *
                                      getTotalUsedQuantity(curr.lotSerial) +
                                  getPriceInNumberDataType(
                                      curr.adjustedOtherQtyPrice
                                          ? curr.adjustedOtherQtyPrice
                                          : curr.basePrice
                                  ) *
                                      getTotalOtherQuantity(curr.lotSerial);
                        return tAdjExtPrice !== null && tAdjExtPrice >= 0
                            ? prev + tAdjExtPrice
                            : 0;
                    }, 0);
                setTAdjAmount(parseFloat(tissueAdjAmount));
                setTissueFlag(true);
                setTProductQty(parseInt(tissueTotal));
            } else {
                setTProductQty(0);
                setTissueFlag(false);
                setTAmount(0);
                setTAdjAmount(0);
            }

            //filter for nonTissue list
            nonTissueProdList = props.itemTableData.filter(
                (item) => item.salesOrg !== 'S030' && !item.accountOwned
            );

            if (nonTissueProdList?.length > 0) {
                const nonTissueTotal = getTotalQuantity(
                    flattenLotSerialArrayOfArrays(
                        'nonTissue',
                        nonTissueProdList
                    )
                );
                const nonTissueAmount = nonTissueProdList.reduce(
                    (prev, current) => {
                        const extPrice = getPriceInNumberDataType(
                            current.extPrice && current.extPrice !== ''
                                ? current.extPrice
                                : current.basePrice
                                ? current.basePrice
                                : 0
                        );
                        return prev + extPrice;
                    },
                    0
                );
                setNTAmount(parseFloat(nonTissueAmount));
                const nonTissueAdjAmount = nonTissueProdList.reduce(
                    (prev, curr) => {
                        const ntAdjExtPrice =
                            !curr.adjustedUsedQtyPrice &&
                            !curr.adjustedOtherQtyPrice
                                ? getPriceInNumberDataType(
                                      curr.extPrice && curr.extPrice !== ''
                                          ? curr.extPrice
                                          : curr.basePrice
                                          ? curr.basePrice
                                          : 0
                                  )
                                : getPriceInNumberDataType(
                                      curr.adjustedUsedQtyPrice
                                          ? curr.adjustedUsedQtyPrice
                                          : curr.basePrice
                                  ) *
                                      getTotalUsedQuantity(curr.lotSerial) +
                                  getPriceInNumberDataType(
                                      curr.adjustedOtherQtyPrice
                                          ? curr.adjustedOtherQtyPrice
                                          : curr.basePrice
                                  ) *
                                      getTotalOtherQuantity(curr.lotSerial);
                        return ntAdjExtPrice !== null && ntAdjExtPrice >= 0
                            ? prev + ntAdjExtPrice
                            : prev;
                    },
                    0
                );
                setNTAdjAmount(parseFloat(nonTissueAdjAmount));
                setNTProductQty(parseInt(nonTissueTotal));
                setNonTissueFlag(true);
            } else {
                setNonTissueFlag(false);
                setNTProductQty(0);
                setNTAmount(0);
                setNTAdjAmount(0);
            }
        }
        setTotalAmount(
            parseFloat(
                (tAmount ? tAmount : 0) +
                    (nTAmount ? nTAmount : 0) +
                    (accAmount ? accAmount : 0)
            )
        );
        setTotalAdjustedAmount(parseFloat(tAdjAmount + nTAdjAmount));

        if (props.itemTableData && props.itemTableData.length == 0) {
            nonTissueProdList = [];
            tissueProdList = [];
            accountOwnedList = [];
            setTissueFlag(false);
            setNonTissueFlag(false);
            setAccountOwnedFlag(false);
        }
    });
    const { t } = useTranslation();

    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
                margin={'0px 2px 0px 1px'}
            >
                <Grid
                    container
                    alignItems={'flex-start'}
                    spacing={2}
                    xs={12}
                    lg={12}
                    md={12}
                >
                    <Grid
                        item
                        xs={4}
                        lg={8}
                        md={8}
                        style={{ fontSize: isMobileDevice() ? '14px' : '13px' }}
                    >
                        {t('common.summaryText')}
                    </Grid>
                    <Grid
                        item
                        xs={4}
                        lg={2}
                        md={2}
                        style={{
                            textAlign: props.isDesktop
                                ? 'right'
                                : isMobileDevice()
                                ? 'center'
                                : 'end',
                            fontSize: isMobileDevice() ? '14px' : '13px',
                        }}
                    >
                        {t('common.qty')}
                    </Grid>
                    <Grid
                        item
                        xs={4}
                        lg={2}
                        md={2}
                        style={{
                            textAlign: 'right',
                            fontSize: isMobileDevice() ? '14px' : '13px',
                        }}
                    >
                        {t('reportUsage.summary.amount')}
                    </Grid>
                    {nonTissueFlag &&
                        (countryISOCode === 'US' ? (
                            <>
                                <Grid
                                    item
                                    xs={4}
                                    lg={8}
                                    md={8}
                                    style={{
                                        fontFamily: 'AvenirNextWorld Regular',
                                        fontSize: '14px',
                                        color: '#000000',
                                        opacity: 1,
                                    }}
                                >
                                    {t('reportUsage.summary.nonTissue')}
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    lg={2}
                                    md={2}
                                    style={{
                                        fontFamily: 'AvenirNextWorld Regular',
                                        fontSize: '14px',
                                        letterSpacing: '0.1px',
                                        color: '#000000',
                                        opacity: '1',
                                        textAlign: props.isDesktop
                                            ? 'right'
                                            : isMobileDevice()
                                            ? 'center'
                                            : 'end',
                                        paddingRight: props.isDesktop
                                            ? ''
                                            : isMobileDevice()
                                            ? '1px'
                                            : '14px',
                                    }}
                                >
                                    {nTproductQty}
                                </Grid>

                                <Grid
                                    item
                                    xs={4}
                                    lg={2}
                                    md={2}
                                    className={classes.unmodifiedPrices}
                                >
                                    {props.displayPrice && (
                                        <>
                                            <div
                                                className={
                                                    nTAdjAmount !== undefined &&
                                                    nTAdjAmount !== null &&
                                                    nTAdjAmount !== nTAmount
                                                        ? classes.strikedPrices
                                                        : classes.unmodifiedPrices
                                                }
                                            >
                                                {setCurrencyFormat(nTAmount)}
                                            </div>
                                            <div>
                                                {nTAdjAmount !== undefined &&
                                                nTAdjAmount !== null &&
                                                nTAdjAmount !== nTAmount
                                                    ? setCurrencyFormat(
                                                          nTAdjAmount
                                                      )
                                                    : null}
                                            </div>
                                        </>
                                    )}
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid
                                    item
                                    xs={4}
                                    lg={8}
                                    md={8}
                                    style={{
                                        fontFamily: 'AvenirNextWorld Regular',
                                        fontSize: '14px',
                                        color: '#000000',
                                        opacity: 1,
                                    }}
                                >
                                    {t('common.itemsLabel')}
                                </Grid>
                                <Grid
                                    item
                                    xs={4}
                                    lg={2}
                                    md={2}
                                    style={{
                                        fontFamily: 'AvenirNextWorld Regular',
                                        fontSize: '14px',
                                        letterSpacing: '0.1px',
                                        color: '#000000',
                                        opacity: '1',
                                        textAlign: props.isDesktop
                                            ? 'right'
                                            : isMobileDevice()
                                            ? 'center'
                                            : 'end',
                                        paddingRight: props.isDesktop
                                            ? ''
                                            : isMobileDevice()
                                            ? '1px'
                                            : '14px',
                                    }}
                                >
                                    {nTproductQty}
                                </Grid>

                                <Grid
                                    item
                                    xs={4}
                                    lg={2}
                                    md={2}
                                    className={classes.unmodifiedPrices}
                                >
                                    {props.displayPrice && (
                                        <>
                                            <div
                                                className={
                                                    nTAdjAmount !== undefined &&
                                                    nTAdjAmount !== null &&
                                                    nTAdjAmount !== nTAmount
                                                        ? classes.strikedPrices
                                                        : classes.unmodifiedPrices
                                                }
                                            >
                                                {setCurrencyFormat(nTAmount)}
                                            </div>
                                            <div>
                                                {nTAdjAmount !== undefined &&
                                                nTAdjAmount !== null &&
                                                nTAdjAmount !== nTAmount
                                                    ? setCurrencyFormat(
                                                          nTAdjAmount
                                                      )
                                                    : null}
                                            </div>
                                        </>
                                    )}
                                </Grid>
                            </>
                        ))}
                    {tissueFlag && (
                        <>
                            <Grid
                                item
                                xs={4}
                                lg={8}
                                md={8}
                                style={{
                                    fontFamily: 'AvenirNextWorld Regular',
                                    fontSize: '14px',
                                    color: '#393939',
                                    opacity: 1,
                                    lineHeight: '19px',
                                }}
                            >
                                {t('reportUsage.summary.tissue')}
                            </Grid>
                            <Grid
                                item
                                xs={4}
                                lg={2}
                                md={2}
                                style={{
                                    textAlign: props.isDesktop
                                        ? 'right'
                                        : isMobileDevice()
                                        ? 'center'
                                        : 'end',
                                    paddingRight: props.isDesktop
                                        ? ''
                                        : isMobileDevice()
                                        ? '1px'
                                        : '14px',
                                }}
                                className={classes.unmodifiedPrices}
                            >
                                {tProductQty}
                            </Grid>

                            <Grid
                                item
                                xs={4}
                                lg={2}
                                md={2}
                                className={classes.unmodifiedPrices}
                            >
                                {props.displayPrice && (
                                    <>
                                        <div
                                            className={
                                                tAdjAmount !== 0 &&
                                                tAdjAmount !== tAmount
                                                    ? classes.strikedPrices
                                                    : classes.unmodifiedPrices
                                            }
                                        >
                                            {!isNaN(parseFloat(tAmount))
                                                ? setCurrencyFormat(tAmount)
                                                : setCurrencyFormat(0)}
                                        </div>
                                        <div>
                                            {tAdjAmount !== 0 &&
                                            tAdjAmount !== tAmount
                                                ? setCurrencyFormat(tAdjAmount)
                                                : null}
                                        </div>
                                    </>
                                )}
                            </Grid>
                        </>
                    )}
                    {accountOwnedFlag && (
                        <>
                            <Grid
                                item
                                xs={5}
                                lg={8}
                                md={8}
                                className={
                                    props.isDesktop
                                        ? classes.desktopStyle
                                        : props.isMobile
                                        ? classes.mobileStyle
                                        : classes.inlineStyle
                                }
                                style={{
                                    fontFamily: 'AvenirNextWorld Regular',
                                    fontSize: '14px',
                                    color: '#393939',
                                    flexDirection: props.isMobile
                                        ? 'column'
                                        : 'row',
                                }}
                            >
                                {accountOwnedFlag && (
                                    <>
                                        <div className={classes.divStyle}>
                                            {props.accountNotBilled &&
                                                props.accountNotBilled}
                                        </div>
                                        <div>
                                            {props.accountLabel &&
                                                props.accountLabel}
                                        </div>
                                    </>
                                )}
                            </Grid>
                            <Grid
                                item
                                xs={3}
                                lg={2}
                                md={2}
                                style={{
                                    textAlign: props.isDesktop
                                        ? 'right'
                                        : props.isMobile
                                        ? 'center'
                                        : 'end',
                                    paddingRight: props.isDesktop
                                        ? ''
                                        : props.isMobile
                                        ? '30px'
                                        : '14px',
                                }}
                                className={classes.unmodifiedPrices}
                            >
                                {accProductQty}
                            </Grid>

                            <Grid
                                item
                                xs={4}
                                lg={2}
                                md={2}
                                className={classes.unmodifiedPrices}
                            >
                                {props.displayPrice &&
                                    setCurrencyFormat(accAmount)}
                            </Grid>
                        </>
                    )}

                    <Grid
                        item
                        xs={4}
                        lg={8}
                        md={8}
                        style={{
                            fontSize: !isMobileDevice() ? '16px' : 'unset',
                        }}
                    >
                        {t('common.totalText')}
                        {/* {t('common.totalText')} */}
                    </Grid>
                    <Grid
                        item
                        xs={4}
                        lg={2}
                        md={2}
                        style={{
                            textAlign: props.isDesktop
                                ? 'right'
                                : isMobileDevice()
                                ? 'center'
                                : 'end',
                            paddingRight: props.isDesktop
                                ? ''
                                : isMobileDevice()
                                ? '1px'
                                : '14px',
                            fontSize: !isMobileDevice() ? '16px' : 'unset',
                        }}
                    >
                        {(tProductQty ? tProductQty : 0) +
                            (nTproductQty ? nTproductQty : 0) +
                            (accProductQty ? accProductQty : 0)}
                    </Grid>
                    {props.displayPrice && (
                        <Grid
                            item
                            xs={4}
                            lg={2}
                            md={2}
                            className={classes.unmodifiedPrices}
                            style={{
                                fontSize: !isMobileDevice() ? '16px' : 'unset',
                            }}
                        >
                            <div
                                className={
                                    totalAdjustedAmount !== totalAmount
                                        ? classes.strikedPrices
                                        : classes.unmodifiedTotalPrice
                                }
                            >
                                {setCurrencyFormat(totalAmount)}
                            </div>
                            {totalAdjustedAmount !== totalAmount && (
                                <StyledTotalPrice>
                                    {setCurrencyFormat(totalAdjustedAmount)}
                                </StyledTotalPrice>
                            )}
                        </Grid>
                    )}
                </Grid>
            </Box>
        </>
    );
};

export default SummaryMobile;
